import { Button, Col, Form, Modal, Row } from 'antd';
import React, { useCallback, useEffect } from 'react';

import { elementWithLoading } from '../../../components/LoadingWrapper';
import { AddOrEditModalProps, FormValues } from '../../../types/types';
import { confirmClose } from '../../../utils/confirmClose';
import { useUserForm } from '../../../utils/hooks/useUserForm';
import styles from './AddOrEditModal.module.css';
import { UserFormFields } from './UserFormFields';

export const AddOrEditModal = ({ modalVisible, user, onCancel, onSuccess }: AddOrEditModalProps): JSX.Element => {
  const [form] = Form.useForm<FormValues>();

  const {
    wasFormChanged,
    roles,
    loading,
    loadingRoles,
    titleAndBtnText,
    initialValues,
    handleFormValuesChange,
    resetForm,
    loadRoles,
    handleSubmit
  } = useUserForm({ user, onSuccess, form });

  const handleCancel = useCallback(() => {
    wasFormChanged ? confirmClose(onCancel) : onCancel();
  }, [wasFormChanged, onCancel]);

  useEffect(() => {
    resetForm();
  }, [resetForm, modalVisible]);

  useEffect(() => {
    loadRoles();
  }, [loadRoles]);

  const formElement = (
    <Form<FormValues>
      layout="vertical"
      form={form}
      onFinish={(values) => {
        void handleSubmit(values);
      }}
      onFinishFailed={({ errorFields }) => {
        form.scrollToField(errorFields[0].name);
      }}
      onValuesChange={handleFormValuesChange}
      initialValues={initialValues}
    >
      <UserFormFields user={user} roles={roles} loadingRoles={loadingRoles} />

      <Row gutter={32}>
        <Col className={styles.submitBtnCol} span={24}>
          <Form.Item>
            <Button className={styles.submitBtn} type="primary" htmlType="submit">
              {titleAndBtnText}
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );

  return (
    <Modal
      title={titleAndBtnText}
      wrapClassName="vertical-center-modal"
      open={modalVisible}
      onCancel={handleCancel}
      footer={null}
      width="80%"
    >
      {elementWithLoading(formElement, loading)}
    </Modal>
  );
};
